import {createSelector} from '@ngrx/store';

import * as fromCitizenServicesCategory from './citizens-services-category.reducer';
import {AppState} from 'src/app/store/reducers';


export const currentState = (state: AppState) => (state[fromCitizenServicesCategory.citizensServicesCategoriesFeatureKey]);

export const selectAllCitizensServicesCategory = createSelector(currentState, fromCitizenServicesCategory.selectAll);

export const selectTotolCitizenServiceCategory = createSelector(currentState, fromCitizenServicesCategory.selectTotal);

export const selectModifiedCitizensServiceCategory = createSelector(selectAllCitizensServicesCategory, (citizens) => {
  return citizens.map((citizen) => {
    return {
      ...citizen
    };
  });
});
